import { z } from 'zod';
import { oneOf, pageNum, pageSize, str } from '../../navigation/searchParams';

/** The page's tab, the keys table's paging, and the create and rename dialogs. */
export const developerApiSearch = z.object({
  tab: oneOf(['keys', 'guide']),
  page: pageNum,
  size: pageSize,
  modal: oneOf(['create-key', 'rename-key']),
  id: str,
});
